<script lang="ts" setup>
import { Toast } from 'reka-ui/namespaced';
import type { MaterialSymbolName } from '@/types/materialSymbolNames';
import type { ToastType } from './types';

const isOpen = defineModel<boolean>('open', { required: true });

defineProps<{
  type: ToastType;
  actionIcon?: MaterialSymbolName;
  actionText?: string;
}>();

const emit = defineEmits<{
  actionClick: [];
}>();

defineSlots<{
  default(): any;
}>();
</script>

<template>
  <Toast.Root
    v-model:open="isOpen"
    class="flex w-max max-w-full items-center gap-2x rounded-md border bg-linear-to-r px-4x py-2x shadow-float data-[state=closed]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:animate-in data-[state=open]:slide-in-from-top-full"
    :class="{
      'border-strong-primary from-primary to-primary-hover text-primary': type === 'success',
      'border-strong-error from-error to-error-hover text-error': type === 'error',
      'border-strong-info from-info to-info-hover text-info': type === 'info',
      'border-strong-warning from-warning to-warning-hover text-warning': type === 'warning',
    }"
    data-testid="toast"
  >
    <BaseIcon
      :name="
        {
          success: 'verified' as const,
          error: 'do_not_disturb_on' as const,
          info: 'error' as const,
          warning: 'warning' as const,
        }[type]
      "
    />
    <Toast.Title class="shrink font-medium">
      <slot name="default" />
    </Toast.Title>
    <Toast.Action v-if="actionText" :alt-text="actionText" as-child>
      <BaseButton
        type="button"
        variant="text"
        :icon="actionIcon"
        class="shrink-0"
        @click="emit('actionClick')"
      >
        {{ actionText }}
      </BaseButton>
    </Toast.Action>
    <Toast.Close as-child>
      <BaseIconButton icon="close" :alt="$t('buttons.close')" class="ml-auto" />
    </Toast.Close>
  </Toast.Root>
</template>
